<section class="resource-container container-fluid chapter">
  <!-- History Control -->
  <nav mat-tab-nav-bar class="mat-history-nav-bar" mat-stretch-tabs="false" [tabPanel]="tabPanel">
    @for (hi of history.items; track hi; let i = $index) {
      @if (i > 0) {
        <i class="material-icons mat-history-spacer">keyboard_arrow_right</i>
      }
      <a
        mat-tab-link
        tabindex="{{ i + 2 }}"
        class="type-{{ hi.sitetype }} mat-history-link mat-tab-link"
        [active]="history.isActive(i)"
        (click)="breadcrumbClick(hi.sitetype, hi.id, hi.id2, i)"
      >
        @if (hi.sitetype === 'timeline') {
          <mat-icon>query_builder</mat-icon>
        }
        <span class="mat-history-link-text">{{ hi.name | async }}</span>
      </a>
    }
  </nav>
  <!-- History Control End -->
  <mat-tab-nav-panel #tabPanel>
    <div class="row">
      <div class="resourcelist {{ listClass }}" [hidden]="!listActive">
        <mat-card appearance="filled" class="resource-card datatable-card">
          <smd-datatable
            #list
            [paginated]="true"
            [responsive]="true"
            [placeFilterInDatatableHeader]="false"
            [hidden]="!listActive"
            [title]="listTitle"
            (onAddView)="addViewFromEvent('list', $event)"
            (onCloseView)="close('list')"
            (onError)="handleErrorInView('list', $event)"
          >
            <smd-datatable-header
              [actionBarConfigs]="listActionBarConfigs"
              [title]="listTitle"
              (onEdit)="addView('list', 'get', $event[objectIdAttr], null, true)"
              (onDelete)="listDelete($event)"
              (onAction)="actionBarClick($event.conf, $event.selectedObjectIds)"
            ></smd-datatable-header>
          </smd-datatable>
        </mat-card>
      </div>

      @if ((detail1Resource | async) != null) {
        <div class="resourcedetail resourcedetail1 {{ detail1Class }} ">
          <mat-card appearance="filled" class="resource-card datatable-card">
            <resource-detail
              #detail1
              [setResource]="detail1Resource"
              (afterDelete)="close('detail1', true)"
              (onAddView)="addViewFromEvent('detail1', $event)"
              (onCloseView)="close('detail1', $event?.RefreshActive)"
              (onDataChanged)="refreshListData()"
              [startEdit]="detail1startEdit"
            ></resource-detail>
          </mat-card>
        </div>
      }

      <div class="resourcewizard {{ wizardClass }}" [hidden]="!wizardActive">
        <mat-card appearance="filled" class="resource-card datatable-card">
          <resource-wizard
            #wizard
            (onAddView)="addViewFromEvent('wizard', $event)"
            (onCloseView)="close('wizard', $event?.RefreshActive)"
            (onDataChanged)="refreshListData()"
          ></resource-wizard>
        </mat-card>
      </div>

      <div class="resourcetimeline {{ timelineClass }}" [hidden]="!timelineActive">
        <mat-card appearance="filled" class="resource-card datatable-card">
          <smd-timeline
            #timeline
            [title]="timelineTitle"
            [actionBarConfigs]="timelineActionBarConfigs"
            [paginated]="true"
            [hidden]="!timelineActive"
            (onAddView)="addViewFromEvent('timeline', $event)"
            (onCloseView)="close('timeline')"
            (onError)="handleErrorInView('timeline', $event)"
          >
          </smd-timeline>
        </mat-card>
      </div>

      @if ((detail2Resource | async) != null) {
        <div class="resourcedetail resourcedetail2 {{ detail2Class }} ">
          <mat-card appearance="filled" class="resource-card datatable-card">
            <resource-detail
              #detail2
              [setResource]="detail2Resource"
              (afterDelete)="close('detail2', true)"
              (onAddView)="addViewFromEvent('detail2', $event)"
              (onCloseView)="close('detail2', $event?.RefreshActive)"
              (onDataChanged)="refreshListData()"
              [startEdit]="detail2startEdit"
            ></resource-detail>
          </mat-card>
        </div>
      }
    </div>
  </mat-tab-nav-panel>
</section>
